import React, { createContext, useContext, useState, useEffect } from 'react';
import walletService from '../services/walletService';

export const WalletContext = createContext(null);

export function WalletProvider({ children }) {
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedWalletType, setSelectedWalletType] = useState('spot');

  const loadWallets = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const data = await walletService.getWallets();
      setWallets(data);
    } catch (error) {
      console.error('Error loading wallets:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadWallets();
  }, []);

  const filteredWallets = wallets.filter(w => w.wallet_type === selectedWalletType);

  const totalBalance = filteredWallets.reduce((sum, wallet) => {
    return sum + (parseFloat(wallet.value_usdt) || 0);
  }, 0);

  const availableBalance = filteredWallets.reduce((sum, wallet) => {
    const totalVal = parseFloat(wallet.value_usdt) || 0;
    const balance = parseFloat(wallet.balance) || 0;
    const locked = parseFloat(wallet.locked) || 0;
    
    // Calculate available value proportional to available quantity
    const availableRatio = balance > 0 ? (balance - locked) / balance : 0;
    return sum + (totalVal * availableRatio);
  }, 0);

  const value = {
    wallets,
    filteredWallets,
    loading,
    selectedWalletType,
    setSelectedWalletType,
    totalBalance,
    availableBalance,
    refreshWallets: loadWallets
  };

  return (
    <WalletContext.Provider value={value}>
      {children}
    </WalletContext.Provider>
  );
}

export function useWallet() {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWallet must be used within WalletProvider');
  }
  return context;
}